import { useState } from "react";
import { toast } from "react-toastify";
import { deleteCrewUser } from "../API";
import deleteIcon from "../assets/images/delete2.png";
import AddStepUpForemanModal from "./AddStepUpForemanModal";

const StepUpForemanListModal = (props) => {
  const { stepUpForemen, userOptions, onAddNewMember } = props;
  const [loading, setLoading] = useState(false);
  const crewTableHeadings = ["Employee ID", "Name", "Action"];

  const onDeleteStepUpForeman = async (item) => {
    setLoading(true);
    await deleteCrewUser(item?.id)
      .then((res) => {
        if (res?.status === 204) {
          onAddNewMember();
          toast.success("Entry Deleted Successfully");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Unable to delete crew user");
      });
  };

  return (
    <>
      <div
        className="modal fade add-new-timesheet-modal"
        id="stepupforemanmodal"
        tabIndex="-1"
        aria-labelledby="stepupforemanmodallabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div
            style={{ maxHeight: "600px", width: "600px"}}
            className="modal-content"
          >
            <div className="modal-header header-items-align">
              <h5
                className="modal-title font-weight-bold"
                id="stepupforemanmodallabel"
              >
                Step-up foreman list
              </h5>
              <button
                type="button"
                className="btn primary-btn-outlined mb-1 px-1"
                // data-bs-dismiss="modal"
                data-bs-toggle="modal"
                data-bs-target="#addstepupforeman"
                // aria-label="Close"
              >
                + Add more
              </button>
            </div>
            <div className="crew-tb overflow-auto">
              <table className="table table-striped">
                <thead>
                  <tr>
                    {stepUpForemen?.length > 0
                      ? crewTableHeadings?.map((item, key) => (
                          <th scope="col" className="table-heading" key={key}>
                            <h6 className="mt-3">{item}</h6>
                          </th>
                        ))
                      : ""}
                  </tr>
                </thead>
                <tbody>
                  {stepUpForemen && stepUpForemen.length > 0 ? (
                    stepUpForemen.map((item, key) => {
                      
                      return (
                        <tr
                          // className={
                          //   selectedUser.id === item?.id ? "activeRow" : ""
                          // }
                          // onClick={() => setSelectedUser(item)}
                          key={key}
                        >
                          <td>
                            {item?.user?.employee_id
                              ? item?.user?.employee_id
                              : "NA"}
                          </td>
                          <td>{item?.user?.name}</td>
                          <td>
                            <div className="icons">
                              <img
                                src={deleteIcon}
                                alt=""
                                className="img-fluid crew-management-delete-icon"
                                onClick={() => onDeleteStepUpForeman(item)}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <h5 className="m-3">No data found</h5>
                  )}
                </tbody>
              </table>
            </div>
            <div>
              <div className="add-new-project-footer">
                <button
                  data-bs-dismiss="modal"
                  type="button"
                  className="primary-btn-less-width"
                  aria-label="Close"
                >
                  Close
                </button>
                {loading && (
                  <div
                    className="spinner-border loader-styles me-3"
                    role="status"
                  ></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddStepUpForemanModal
        userOptions={userOptions}
        onAddNewMember={onAddNewMember}
        setLoading={setLoading}
      />
    </>
  );
};

export default StepUpForemanListModal;
